export const SET_MEETING = 'events/SET_MEETING';

/**
 * @param meeting
 * @returns {{payload: *, type: string}}
 */
export const setMeeting = (meeting) => ({ type: SET_MEETING, payload: meeting });
